module.exports = __webpack_public_path__ + "static/logo-923df4e9c8eb104001be441d1dadcf0c.png";